var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLadmfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1840 800",
    width: 460,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1442,223)",
    d: "m0 0h94l31 2 31 4 30 6 17 5 25 9 20 10 15 10 15 14 11 14 7 11 6 15 4 18 1 15-6 2-179-1-9-18-7-8-14-7-16-4-21-2h-22l-22 2-10 3-8 5-7 8-2 9 2 8 2 4 7 4 16 4 159 23 40 7 25 6 20 7 16 8 12 8 13 11 10 11 8 13 6 15 3 15 1 9v34l-3 19-6 18-11 18-11 13-8 8-13 9-17 10-18 8-24 8-33 7-26 4-28 3-19 1h-98l-17-1-37-5-26-5-25-6-21-8-16-8-16-10-13-11-7-7-10-15-4-8-4-10-5 2-9 11-11 14-15 16-10 10-11 9-13 10-18 11-17 7-18 5-13 2-26 1-17-1-18-4-13-7-8-7-10-15-5-14-2-11 1-17 6-26 11-41 9-31 15-48 20-65 14-44 8-31 1-5v-9l-4-8-5-6-8-5-17-3h-26l1 12 1 63-1 1-148 1v302l-2 1h-159l-1-1v-292l1-10-148-1v-103l1-1 649-1 13-2h7l-1 5-8 21-10 32-9 28-8 26-12 37-8 26-9 29-12 38-17 59-10 40v9l4 5 9 5 10-1 11-6 12-9 13-12 14-15 13-17 8-10 4-4 89-1h58l46 1 2 6 4 13 5 5 5 6 15 4 21 3h41l14-3 14-6 8-7 3-7v-12l-4-10-1-3-5-2-11-4-21-4-52-8-42-6-37-6-39-6-24-5-20-7-13-7-14-10-12-11-9-12-8-15-5-16-3-16v-32l2-13 5-18 10-19 9-11 8-9 11-9 14-9 17-8 21-8 34-8 27-4z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(56,236)",
    d: "m0 0h179l6 2 4 5 9 13 14 19 24 34 10 13 14 20 13 18 14 19 11 16 14 19 10 14 16 24 8 6-2-26v-196h156l1 1v334l1 70-3 3h-174l-4-2-27-36-14-19-24-32-14-19-14-18-12-17-14-18-13-18-10-13-13-18-6-8-4-3-3-3 1 76 1 146-3 2h-152l-1-1v-406z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163)",
    d: "m0 0h68l-1 4-2 1 12 4 16 9 12 11 10 13 10 17 4 13 2 12v23l-4 15-8 16-10 14-7 8-13 10-16 8-14 5-11 2h-30l-15-4-16-8-9-6-12-12-9-14-6-10-6-18-2-9v-23l6-23 6-11 8-12 9-11 10-9 14-8 7-2-1-2z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1232,5)",
    d: "m0 0",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163,3)",
    d: "m0 0",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadmfLogo);
export default __webpack_public_path__ + "static/media/ladmf-logo.0993b173.svg";
export { ForwardRef as ReactComponent };